import React from "react";
import {Container, IntroPar, Box} from "../styles/intro_styles";
import {StartButton} from "../styles/stepper_styles.js";


export default function Introduction(props) {
  return (
    <Container>
      <Box>
        <IntroPar>
          Welcome to the Ditto demo! Entity matching refers to the task of
          determining whether two different data items refer to the same
          real-world entity.
          <br />
          <br />
          It is a prevalent problem for many organizations where data
          resides in different sources and duplicates the need to be
          identified and managed. Ditto leverages language models to address
          this problem.
          <br />
          <br /> Go ahead and try it yourself!
          <br />
        </IntroPar>
        {props.activeStep === -1 ? (
          <StartButton onClick={props.handleNext}>Start</StartButton>
        ) : (
          ""
        )}
      </Box>
    </Container>
  );
}

// <PubLink onclick="window.open('https://dl.acm.org/doi/10.1145/3431816','_blank')">
//   {" "}
//   Read our publication{" "}
// // </PubLink>
